import { USERS } from '../models/users';

function delay(ms = 350) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** Lista de usuarios del sistema, sin contraseñas. */
export async function getUsers() {
  await delay();
  return USERS.map(({ password, ...rest }) => rest); // eslint-disable-line no-unused-vars
}

/** Un usuario puntual por id. */
export async function getUserById(id) {
  await delay(200);
  const user = USERS.find((u) => u.id === id);
  if (!user) return null;
  const { password, ...rest } = user; // eslint-disable-line no-unused-vars
  return rest;
}
